import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

// const storage = process.env.REACT_APP_BC4T_DEV === 'true' ? sessionStorage : localStorage
const client = axios.create({ baseURL: process.env.REACT_APP_API_URL })

client.interceptors.request.use(function (config) {
  const token = localStorage.getItem("access_token")
  config.headers.Authorization = `Bearer ${token}`
  return config;
}, function (error) {
  return Promise.reject(error);
})

export const request = function (options, track=true) {
  const req = client(options)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Request Failed:", error.config);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Headers:", error.response.headers);
      } else {
        console.error("Error Message:", error.message);
      }

      return Promise.reject(error.response || error.message);
    });
  return track ? trackPromise(req) : req
}

export const requestWithLoadingTimeout = async function (options, beforeLoading, afterLoading, onError) {
  var timer = setTimeout(beforeLoading, options.timeout || 250)
  return request(options).then((response) => {
    clearTimeout(timer)
    afterLoading(response)
    return response
  }).catch((error) => {
    clearTimeout(timer)
    if (onError) onError(error)
    return error
  })
}

export const getForIndex = (fragment, recordState, setRecordState) => {
  const params = { page: recordState.currentPage, per: recordState.perPage }
  for (var key in recordState.filter) { params[key] = recordState.filter[key] }
  requestWithLoadingTimeout(
    { method: "get", url: fragment, params: params },
    () => setRecordState({ ...recordState, loadingInProgress: true }),
    (response) => {
      setRecordState({ ...recordState, data: response.results, totalMatches: response.total_count, totalPages: response.total_pages, loadingInProgress: false })
    }
  )
}
export { client };
export default request;
